import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  // Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  X as ClearIcon,
  Search as SearchIcon,
  FileText as DetailIcon,
} from 'react-feather';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import esLocale from 'date-fns/locale/es';
import { useSelector, useDispatch } from 'react-redux';
import CustomTextField from '../../../components/Inputs/TextField/CustomTextField';
import CustomAutocomplete from '../../../components/Inputs/Autocomplete/CustomAutocomplete';
import { SUPER_ADMIN, CLIENT_SELLER } from '../../../utils/const/user_types';
import { PAYMENT_STATUS_APROBADO } from '../../../utils/const/paymentStatus';
import useStyles from './styles';
import SplashScreen from '../../../components/Loading/SplashScreen';
import thousandSeparator from '../../../utils/thousandSeparator';
import { saveFilters } from '../../../actions/filterActions';
import {
  ORDER_APPROVED, ORDER_CANCELLED, ORDER_PENDING,
} from '../../../utils/const/orderStatus';

function Results({
  orders,
  count,
  orderSearchValue,
  setOrderSearchValue,
  sellers,
  selectedSellers,
  setSelectedSellers,
  page,
  setPage,
  limit,
  setLimit,
  role,
  clients,
  selectedClient,
  setSelectedClient,
  stores,
  selectedStores,
  setSelectedStores,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  history,
}) {
  const classes = useStyles();
  // const [selectedOrders, setSelectedOrders] = useState([]);
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.account);
  const tipEnabled = user.module && user.module.tipEnabled;
  const [currentOrders, setCurrentOrders] = useState(orders);
  const currentTotalAmount = currentOrders.reduce((sum, o) => {
    if (o.status === ORDER_APPROVED) {
      return sum + (o.totalAmount || 0);
    }
    return sum;
  }, 0);
  const paymentTotals = currentOrders.reduce((acc, o) => {
    if (o.payments) {
      o.payments.filter((p) => p.status === PAYMENT_STATUS_APROBADO).forEach((p) => {
        const type = p.type ? p.type.toLowerCase() : '';
        acc[type] = (acc[type] || 0) + (p.amount || 0);
      });
    }
    return acc;
  }, {});
  const [filters, setFilters] = useState({
    page,
    limit,
    orderSearchValue,
    selectedSellers,
    selectedClient,
    selectedStores,
    startDate,
    endDate,
  });
  useEffect(() => {
    setCurrentOrders(orders);
  }, [orders]);

  // const handleSelectAllOrders = (e) => {
  //   setSelectedOrders(e.target.checked
  //     ? currentOrders.map((order) => order.id)
  //     : []);
  // };

  // const handleSelectOneOrder = (e, orderId) => {
  //   if (!selectedOrders.includes(orderId)) {
  //     setSelectedOrders((prevSelected) => [...prevSelected, orderId]);
  //   } else {
  //     setSelectedOrders((prevSelected) => prevSelected.filter((id) => id !== orderId));
  //   }
  // };

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
    setFilters((prevVal) => ({ ...prevVal, page: newPage }));
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setFilters((prevVal) => ({ ...prevVal, limit: e.target.value }));
  };

  // const enableBulkOperations = selectedOrders.length > 0;
  // const selectedSomeOrders = selectedOrders.length > 0
  // && selectedOrders.length < currentOrders.length;
  // const selectedAllOrders = selectedOrders.length === currentOrders.length;
  const handleOrderSearchValueChange = (e) => {
    e.preventDefault();
    setOrderSearchValue(e.target.value);
    setFilters((prevVal) => ({ ...prevVal, orderSearchValue: e.target.value }));
  };
  const handleGoToDetail = (orderId) => {
    dispatch(saveFilters(filters));
    history.push(`/pedidos/${orderId}/detalle`);
  };

  const getStatusChip = (status) => {
    if (!status) return null;
    const s = status.toLowerCase();
    if (s === ORDER_APPROVED) {
      return <Chip label={s} size="small" style={{ backgroundColor: '#4caf50', color: '#fff' }} />;
    }
    if (s === ORDER_CANCELLED) {
      return <Chip label={s} size="small" style={{ backgroundColor: '#f44336', color: '#fff' }} />;
    }
    if (s === ORDER_PENDING) {
      return <Chip label={s} size="small" style={{ backgroundColor: '#ff9800', color: '#fff' }} />;
    }
    return <Chip label={s} size="small" />;
  };

  if (!selectedClient.id) return <SplashScreen />;
  return (
    <div>
      <Card>
        <Box
          p={2}
          minHeight={56}
          display="flex"
          alignItems="center"
        >
          <Grid container spacing={1}>
            {role === SUPER_ADMIN
              && <Grid item md={2} xs={12}>
                <CustomAutocomplete
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disablePortal
              noOptionsText='Sin clientes para mostrar'
              id="combo-box-demo"
              placeholder="Buscar cliente"
              options={clients}
              value={selectedClient}
              getOptionLabel={(option) => `${option.name}`}
              onChange={(e, value) => {
                if (value === null) {
                  setSelectedClient({
                    id: clients[0].id,
                    name: clients[0].name,
                  });
                  return;
                }
                setSelectedClient({
                  id: value.id,
                  name: value.name,
                });
                setFilters((prevVal) => ({
                  ...prevVal,
                  selectedClient: {
                    id: value.id,
                    name: value.name,
                  },
                }));
              }}
              renderInput={(params) => (
                <CustomTextField
                {...params}
                label="Buscar cliente"
                variant="outlined"
                />
              )}
              />
              </Grid>
            }
            <Grid item md={2} xs={12}>
              <CustomTextField
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon
                        fontSize="small"
                        color="action"
                      >
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                }}
                onChange={handleOrderSearchValueChange}
                placeholder="Buscar n° pedido"
                value={orderSearchValue}
                variant="outlined"
              />
            </Grid>
            {user.role !== CLIENT_SELLER && <Grid item md={2} xs={12}>
              <CustomAutocomplete
                multiple
                disableCloseOnSelect
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="Sin vendedores para mostrar"
                options={sellers}
                value={selectedSellers}
                getOptionLabel={(option) => `${option.name} ${option.lastname}`}
                onChange={(e, value) => {
                  setSelectedSellers(value);
                  setFilters((prevVal) => ({ ...prevVal, selectedSellers: value }));
                }}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    label="Vendedores"
                    variant="outlined"
                  />
                )}
              />
            </Grid>}
            {user.role !== CLIENT_SELLER && <Grid item md={2} xs={12}>
              <CustomAutocomplete
                multiple
                disableCloseOnSelect
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="Sin locales para mostrar"
                options={stores}
                value={selectedStores}
                getOptionLabel={(option) => option.name || ''}
                onChange={(e, value) => {
                  setSelectedStores(value);
                  setFilters((prevVal) => ({ ...prevVal, selectedStores: value }));
                }}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    label="Locales"
                    variant="outlined"
                  />
                )}
              />
            </Grid>}
            <Grid item md={2} xs={12}>
              <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={esLocale}
                >
                <DatePicker
                  views={['day', 'month', 'year']}
                  label="Fecha de inicio"
                  value={startDate}
                  onChange={(value) => {
                    if (value === null) {
                      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
                      return;
                    }
                    setStartDate(value);
                    setFilters((prevVal) => ({ ...prevVal, startDate: value }));
                  }}
                  renderInput={(params) => (
                  <CustomTextField
                  {...params}
                  variant='outlined'
                  fullWidth
                  />
                  )}
                />
                </LocalizationProvider>
            </Grid>
            <Grid item md={2} xs={12}>
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={esLocale}
              >
              <DatePicker
                views={['day', 'month', 'year']}
                label="Fecha límite"
                value={endDate}
                onChange={(value) => {
                  if (value === null) {
                    setEndDate(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
                    return;
                  }
                  setEndDate(value);
                  setFilters((prevVal) => ({ ...prevVal, endDate: value }));
                }}
                renderInput={(params) => (
                <CustomTextField
                {...params}
                variant='outlined'
                fullWidth
                />
                )}
              />
              </LocalizationProvider>
            </Grid>
            <Tooltip title='Limpiar fechas'>
              <IconButton
                component={Button}
                onClick={() => {
                  setEndDate(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
                  setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
                }}
              >
                <SvgIcon fontSize="small">
                  <ClearIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Grid>
        </Box>
      </Card>
      <Box mt={2} mb={2}>
        <Card>
          <Box p={2} display="flex" alignItems="center">
            <Grid container spacing={2}>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Total pedidos:</Typography>
                <Typography variant="h4">{count}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Monto total:</Typography>
                <Typography variant="h4">$ {thousandSeparator(currentTotalAmount, '.')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Crédito:</Typography>
                <Typography variant="h4">$ {thousandSeparator(paymentTotals.credito || 0, '.')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Débito:</Typography>
                <Typography variant="h4">$ {thousandSeparator(paymentTotals.debito || 0, '.')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Efectivo:</Typography>
                <Typography variant="h4">$ {thousandSeparator(paymentTotals.efectivo || 0, '.')}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="textSecondary">Transferencia:</Typography>
                <Typography variant="h4">$ {thousandSeparator(paymentTotals.transferencia || 0, '.')}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>
      <TableContainer component={Card}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Grid container spacing={0}>
                  <Grid item xs={8}>
                  N° de Pedido
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                Folio
              </TableCell>
              <TableCell>
                Vendedor
              </TableCell>
              <TableCell>
                Total
              </TableCell>
              {tipEnabled && <TableCell>Subtotal</TableCell>}
              {tipEnabled && <TableCell>Propina</TableCell>}
              <TableCell>
                Fecha
              </TableCell>
              <TableCell>
                Documento
              </TableCell>
              <TableCell>
                Estado
              </TableCell>
              <TableCell align="right">
              <TablePagination
                component="div"
                count={count}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={count <= 0 ? 0 : page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                labelRowsPerPage="Filas por página"
              />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentOrders ? currentOrders.map((order) => (
                <TableRow
                  hover
                  key={order.id}
                >
                  <TableCell>
                    <Box
                      display="flex"
                      alignItems="center"
                    >
                      <Avatar
                        className={classes.avatar}
                      >
                      </Avatar>
                      <Typography
                        color="inherit"
                        variant="h6"
                      >
                        {order.orderNumber}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {order.billing && order.billing.folio ? order.billing.folio : ''}
                  </TableCell>
                  <TableCell>
                    {order.user ? `${order.user.name} ${order.user.lastname}` : ''}
                  </TableCell>
                  <TableCell>
                    ${thousandSeparator(order.totalAmount, '.')}
                  </TableCell>
                  {tipEnabled && (
                    <TableCell>
                      {order.subtotal != null ? `$${thousandSeparator(order.subtotal, '.')}` : ''}
                    </TableCell>
                  )}
                  {tipEnabled && (
                    <TableCell>
                      {order.tip != null ? `$${thousandSeparator(order.tip, '.')}` : ''}
                    </TableCell>
                  )}
                  <TableCell>
                    {new Date(order.createdAt)
                      .toLocaleDateString('en-CA', { timeZone: 'America/Santiago' })
                      .split('-')
                      .reverse()
                      .join('-')}
                  </TableCell>
                  <TableCell>
                    {order.billing && order.billing.type ? order.billing.type.toUpperCase() : null}
                  </TableCell>
                  <TableCell>
                    {getStatusChip(order.status)}
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title='Ver detalle'>
                      <IconButton
                        component={Button}
                        onClick={() => handleGoToDetail(order.id)}
                      >
                        <SvgIcon fontSize="small">
                          <DetailIcon />
                        </SvgIcon>
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
            ))
              : <TableRow>
                <TableCell align="center" colSpan="5">
                No hay pedidos para mostrar
                </TableCell>
                </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

Results.propTypes = {
  className: PropTypes.string,
  orderSearchValue: PropTypes.string.isRequired,
  setOrderSearchValue: PropTypes.func.isRequired,
  sellers: PropTypes.array,
  selectedSellers: PropTypes.array,
  setSelectedSellers: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  setLimit: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  orders: PropTypes.array.isRequired,
  stores: PropTypes.array,
  selectedStores: PropTypes.array,
  setSelectedStores: PropTypes.func.isRequired,
};

Results.defaultProps = {
  orders: [],
  sellers: [],
  selectedSellers: [],
  stores: [],
  selectedStores: [],
};

export default Results;
